import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    leftLinerGradient: {
        position: 'absolute',
        width: '70%',
        left: 0,
        top: 0,
        bottom: 0,
    },
    bottomLinerGradient: {
        position: 'absolute',
        width: '100%',
        height: 360,
        bottom: 0,
    },
    topLinerGradient: {
        opacity: 0.7,
        position: 'absolute',
        width: '100%',
        height: 96,
        top: 0,
    },
});

export default styles;
